import { Localization } from "../../../common/localizable-component";
import { PageHeaderLocalization } from "./page-header-types";

export const PAGE_HEADER_LOCALIZATION: Localization<PageHeaderLocalization> = {
  en: {
    play: "Pause playback",
    pause: "Resume playback"
  },
  de: {
    play: "Wiedergabe anhalten",
    pause: "Wiedergabe fortsetzen"
  },
  sv: {
    play: "Pausa uppspelning",
    pause: "Återuppta uppspelning"
  },
  nl: {
    play: "Afspelen onderbreken",
    pause: "afspelen hervatten"
  },
  it: {
    play: "Interrompere la riproduzione",
    pause: "Riprendere la riproduzione"
  },
  hu: {
    play: "Lejátszás szüneteltetése",
    pause: "Lejátszás folytatása"
  },
  da: {
    play: "Pause playback",
    pause: "Fortsæt playback"
  },
  fr: {
    play: "Pause de la lecture",
    pause: "Reprise de la lecture"
  },
  es: {
    play: "Pausa la reproducción",
    pause: "Reanudar la reproducción"
  },
  pl: {
    play: "Wstrzymanie odtwarzania",
    pause: "Wznowienie odtwarzania"
  },
  ro: {
    play: "Pauză la redare",
    pause: "Reluarea redării"
  },
  hr: {
    play: "Pauziraj reprodukciju",
    pause: "Nastavak reprodukcije"
  },
  cs: {
    play: "Pozastavení přehrávání",
    pause: "Obnovení přehrávání"
  },
  sl: {
    play: "Prekinitev predvajanja",
    pause: "Nadaljevanje predvajanja"
  }
};
